import React from 'react'

const SortByAscendingIcon = () => {
  return (
    <svg
    width="19"
    height="15"
    viewBox="0 0 19 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Group 2040">
      <g id="Group">
        <path
          id="Vector"
          d="M8.65622 12.3984H0.579535C0.259458 12.3984 0 12.6579 0 12.978V13.5575C0 13.8776 0.259458 14.137 0.579535 14.137H8.65622C8.97624 14.137 9.23575 13.8776 9.23575 13.5575V12.978C9.23575 12.6579 8.9763 12.3984 8.65622 12.3984Z"
          fill="#6F7171"
        />
        <path
          id="Vector_2"
          d="M0.579535 10.4847H7.56791C7.88793 10.4847 8.14745 10.2252 8.14745 9.90516V9.32563C8.14745 9.00555 7.88793 8.74609 7.56791 8.74609H0.579535C0.259458 8.74609 0 9.00555 0 9.32563V9.90516C0 10.2252 0.259458 10.4847 0.579535 10.4847Z"
          fill="#6F7171"
        />
        <path
          id="Vector_3"
          d="M0.579535 6.83235H6.47949C6.79951 6.83235 7.05902 6.5729 7.05902 6.25282V5.67328C7.05902 5.35321 6.79951 5.09375 6.47949 5.09375H0.579535C0.259458 5.09375 0 5.35321 0 5.67328V6.25282C0 6.5729 0.259458 6.83235 0.579535 6.83235Z"
          fill="#6F7171"
        />
        <path
          id="Vector_4"
          d="M0.579535 2.77767H5.39112C5.71114 2.77767 5.97066 2.51821 5.97066 2.19813V1.6186C5.97066 1.29852 5.71114 1.03906 5.39112 1.03906H0.579535C0.259458 1.03906 0 1.29852 0 1.6186V2.19813C0 2.51821 0.259458 2.77767 0.579535 2.77767Z"
          fill="#6F7171"
        />
        <path
          id="Vector_5"
          d="M18.5371 9.73898L18.1273 9.32919C18.0187 9.22053 17.8712 9.15945 17.7175 9.15945C17.5638 9.15945 17.4165 9.22053 17.3077 9.32919L15.3145 11.3224V1.16547C15.3145 0.845395 15.055 0.585938 14.735 0.585938H14.1554C13.8354 0.585938 13.5759 0.845395 13.5759 1.16547V11.3223L11.5826 9.32914C11.4739 9.22041 11.3265 9.15939 11.1728 9.15939C11.0192 9.15939 10.8717 9.22047 10.7631 9.32914L10.3533 9.73892C10.127 9.96523 10.127 10.3322 10.3533 10.5585L14.0354 14.2406C14.1441 14.3493 14.2915 14.4104 14.4452 14.4104C14.5989 14.4104 14.7463 14.3493 14.855 14.2406L18.5371 10.5585C18.7634 10.3322 18.7634 9.96529 18.5371 9.73898Z"
          fill="#6F7171"
        />
      </g>
    </g>
  </svg>
  )
}

export default SortByAscendingIcon              
                
